import VistaMesa from '@mui/icons-material/LocalLibrary';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroVistaMesa extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Vista em mesa';
    }

    getIconeFiltroRapido() {
        return <VistaMesa />;
    }

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return !!registro?.informacaoProcessoSalaSessao?.magistradoVistaEmMesa;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
